import React from 'react'
import { Form } from 'react-bootstrap'
import User from './user'
import BatchLabel from './batch-label'
import Wrapper from './participants-wrapper'

const Users = ({
    value = [],
}) => {
    const renderUser = (user, key) => (<User key={key} user={user} />)
    return value.length > 8
        ? (<Wrapper><BatchLabel count={value.length}/></Wrapper>)
        : (<Wrapper>{value.map(renderUser)}</Wrapper>)
}

export default Users
